import { Navigate, useLocation } from 'react-router-dom'
import { authService } from '../services/authService'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const location = useLocation()
  const isAuthenticated = authService.isAuthenticated()

  if (!isAuthenticated) {
    // Capture the current URL as the redirect target
    const redirectUrl = location.pathname + location.search
    // Redirect to login with the redirect_url parameter
    return <Navigate to={`/auth/login?redirect_url=${encodeURIComponent(redirectUrl)}`} replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
